import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type ExtendedBuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { importanceComponent } from '@nodeTypeConfig/helpers/editComponents/importanceComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { asideWebTypeNotRequired } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { proDefaultBuildingBlocks } from '../../helpers/buildingBlocks/proDefaultBuildingBlocks';
import { extendsSection } from '../../helpers/genericConfigHelpers';

// Extends SECTION => A SECTION without webConfig inside a Pro Theme document or a SHARED_MINI_DATABASE_ITEM item document becomes a PRO_THEME_SECTION
// A Pro Theme is one of the 3 PRO_THEME_HOME_... document types, one of the 5 PRO_..._STANDALONE document types or just WEBPAGE2
const PRO_THEME_SECTION: ExtendedBuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  validationRules: [],
  information: {
    single: 'Titel',
    plural: 'Titels',
    ribonIcon: require('../../../../../img/buildingBlocks/SECTION.svg'),
  },
  ...extendsSection,
  isCollapsedByDefault: false,
  buildingBlocks: [
    ...proDefaultBuildingBlocks.filter((bb) => bb.type !== NodeType.WORD_IMPORT),
    {
      type: NodeType.WORD_IMPORT,
      options: {
        openImportModal: true,
      },
    },
  ],
  edit: [titleComponent, importanceComponent],
  webTab: [asideWebTypeNotRequired],
};

export default PRO_THEME_SECTION;
